<div #mapContainer class="map-container">
  @if (isServiceDown) {
    <div class="service-down-overlay">
      <div class="service-down-card">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="service-down-icon"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
          />
        </svg>
        <h3 class="service-down-title">Map Service Unavailable</h3>
        <p class="service-down-message">
          The ACCDH Team apologizes for this inconvenience, and will let you
          know when service is restored. Thank you.
        </p>
        <button
          type="button"
          class="service-down-retry"
          [disabled]="isLoading"
          (click)="retryMapLoad()"
        >
          Retry Map
        </button>
      </div>
    </div>
  } @else {
    <div id="mapView" #mapView>Map View</div>
    <button
      class="layer-list-toggle"
      (click)="toggleLayerList()"
      [title]="isLayerListExpanded ? 'Hide Layers' : 'Show Layers'"
    >
      <span class="toggle-icon">{{ isLayerListExpanded ? "−" : "+" }}</span>
    </button>
  }
</div>
